document.addEventListener('click', function(e){
  var target = e.target.closest('[data-scroll]');
  if(target){ e.preventDefault(); document.querySelector(target.getAttribute('data-scroll')).scrollIntoView({behavior:'smooth'}); }
});
window.addEventListener('scroll', function(){
  if(window.scrollY > 500){ document.body.classList.add('scrolled'); }
  else { document.body.classList.remove('scrolled'); }
});


document.addEventListener('click', function(e){
  var thumb = e.target.closest('[data-gallery-src]');
  if(!thumb) return;
  var main = document.getElementById('GalleryMainImage');
  if(main){
    main.src = thumb.getAttribute('data-gallery-src');
    main.alt = thumb.getAttribute('data-gallery-alt') || main.alt;
  }
});
